export default {
  colors: {
    black: '#000000',
    white: '#ffffff',
    pink: '#ff4552',
    pinkHover: '#e93d49',
    darkGrey: '#0a090b',
  },
};
